export const MissingClaimsListModalStyles = {
    wrapper:
        "flex max-h-[85vh] min-h-[min(520px,85vh)] w-full flex-col overflow-hidden",
    header:
        "flex shrink-0 items-center gap-3 border-b border-[#F1F5F9] px-5 pb-4",
    backButton:
        "flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-[#F1F5F9]",
    title: "min-w-0 flex-1 text-left text-base font-bold text-[#0F172A]",
    requiredCount: "shrink-0 text-xs text-[#999999]",
    list: "min-h-0 flex-1 overflow-y-auto",
    claimRow:
        "flex items-center gap-3 border-b px-6 border-[#F1F5F9] py-3.5 text-sm text-[#0F172A] last:border-b-0",
    claimIndex: "w-4 shrink-0 text-[#999999]",
    claimBullet: "h-2 w-2 shrink-0 rounded-full bg-[#DB2E2E]",
    closeButtonContainer: "shrink-0 px-5 pt-4 flex justify-end",
    closeButton:
        "flex h-8 w-8 items-center justify-center rounded-full bg-[#F1F5F9] hover:bg-[#F9FAFB]",
};
